import {
  ChangeEvent,
  MouseEvent,
  SyntheticEvent,
  memo,
  useCallback,
} from "react"
import { ReactComponent as IconSearchNormal } from "assets/images/icons/icon-search-normal.svg"
import { ReactComponent as IconClearSearch } from "assets/images/icons/icon-clear-search.svg"
import InputDefault from "components/Input/InputDefault"

interface GroupMemberSearchProps {
  value: string
  placeholder?: string
  onChange: (value: string) => void
  onClear: () => void
  styleInput?: React.CSSProperties
  containerStyle?: React.CSSProperties
}

const preventBubble = (event: SyntheticEvent) => {
  event.preventDefault()
  event.stopPropagation()
}

const SearchInputComponent = (props: GroupMemberSearchProps) => {
  const {
    value,
    placeholder = "Search by either name, email or phone",
    onChange,
    onClear,
    styleInput,
    containerStyle,
  } = props

  const handleInputChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      event.preventDefault()
      event.stopPropagation()
      onChange(event.target.value)
    },
    [onChange]
  )

  const handleClear = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      preventBubble(event)
      onClear()
    },
    [onClear]
  )

  return (
    <div
      className="bg-grayWhite2 p-2 rounded-full flex items-center w-[320px]"
      onClick={preventBubble}
      style={{
        ...containerStyle,
      }}
    >
      <IconSearchNormal
        style={{
          width: 20,
        }}
        onClick={preventBubble}
      />
      <InputDefault
        value={value}
        placeholder={placeholder}
        style={{
          border: "none",
          boxShadow: "none",
          height: 30,
          fontWeight: 400,
          ...styleInput,
        }}
        classCustom="h-11 border rounded bg-grayWhite2 pl-3 pr-3 text-sm font-light text-[#111111] focus:outline-none"
        onClick={preventBubble}
        onChange={handleInputChange}
      />
      {value ? (
        <div
          onClick={handleClear}
          className="h-5 w-5 flex items-center justify-center custom-icon-clear-search cursor-pointer"
        >
          <IconClearSearch />
        </div>
      ) : null}
    </div>
  )
}

export const SearchInput = memo(SearchInputComponent)
